/**
 * Role Names
 *
 * This enum defines all the possible roles that a user can have in the system.
 * These roles should correspond to those defined in the external system (e.g., Pimcore).
 */

export enum RoleName {
    Magnesia = "magnesiaRole",
    PersonalCare = "personalCareRole",
    CoatingSolutions = "coatingSolutionsRole",
    AutoQAdmin = "autoQAdminRole"
}

export const MainRoles = [
    RoleName.Magnesia,
    RoleName.PersonalCare,
    RoleName.CoatingSolutions
];

/**
 * System Roles
 *
 * This constant defines the system-level roles that grant general access to the application.
 * These roles are excluded from the access rights evaluation, as they provide basic functionality.
 */

export const SYSTEM_ROLE_NAMES = ["frontEndUser"];